var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 98,
    height: 98,
    rx: 49,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 75.5C64.1355 75.5 76 63.6355 76 49C76 34.3645 64.1355 22.5 49.5 22.5C34.8645 22.5 23 34.3645 23 49C23 63.6355 34.8645 75.5 49.5 75.5Z",
    fill: "#77CC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6513 41.8264L50.3051 56.1736L49.4997 56.979L45.1811 61.2966L40.057 56.1736L34.3481 50.4637L39.4722 45.3397L45.1811 51.0496L49.4997 46.7309L59.5273 36.7034L64.6513 41.8264Z",
    fill: "#FFF5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.03ec76116e11fda4d5e42e3b0af46611.svg";
export { ForwardRef as ReactComponent };